import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../../constants';
import { OauthAEMConfig } from '../../../../models';
import {
  MethodSelectionPayload,
  SubmitSmsMethod
} from '../../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../../util-service/util-service';
@Injectable({
  providedIn: 'root'
})
export class SubmitSmsMethodSelectionService {
  submitSmsMfaHeader: HttpHeadersPayload = {
    'Content-Type':
      'application/vnd.pingidentity.selectDevicePairingMethod+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitSmsMethodSelection = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    smsMethodSelection: MethodSelectionPayload
  ): Observable<SubmitSmsMethod> => {
    const smsMethodSelectionUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitSmsMethodMfaUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: smsMethodSelectionUrl
      }
    ];

    return new ApiBuilder<MethodSelectionPayload, SubmitSmsMethod>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitSmsMethodMfaUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(smsMethodSelection)
      .httpHeaders(this.submitSmsMfaHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_SMS_METHOD_SELECTION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
